<template>
   <b-col v-bind="settings.container" v-if="ready">
        <form @submit="save">
            <b-tabs lazy :key="version">
                <b-tab v-for="group in fieldGroups" :key="group">
                    <template slot="title">
                        <span v-if="group == ''">{{ $t('default') }}</span>
                        <span v-else>{{ groupName(group) }}</span>
                    </template>

                    <component :is="wrapperComponentElement" v-bind="wrapperComponent">
                        <b-col cols="12" align-self="center" v-for="value in sortedFields" :key="value.key">
                            <b-row :class="{fieldEditing: visibleFieldSettings}" v-if="value.visible && value.group == group">
                                    <b-col :cols="visibleFieldSettings ? 11 : 12">
                                        <IdentityFields :label="$translateLabel(value.label, value.name)" :field="value" v-model="input" @error="fieldError"  :disabled="value.protected" page="model_edit" :extendErrors="httpErrors[value.key]" @input="cleanErrors" :store="$store" :context="context" :translator="$t" v-if="value.visible && value.group == group">
                                            <template v-slot:IdentityFieldSelectRelation v-if="value.module == 'select' && value.type == 'relation' && !settings.slotless">
                                                <SelectRelationUI :field="value" v-model="input" :key="value.key" />
                                            </template>

                                            <template v-slot:IdentityFieldImageCarousel="{ itemSelected, mode }" v-if="value.module == 'image' && value.type == 'carousel' && !settings.slotless">
                                                <MediaLibrary @itemsSelected="itemSelected" :mode="mode" />
                                            </template>

                                            <template v-slot:ProvidedTemplate>
                                                <ComponentView :id="value.provided_template_component" :entrypoint="value.component_template" :field="value" :context="context" v-model="input" :key="value.key" page="model_edit"/>
                                            </template>
                                        </IdentityFields>
                                    </b-col>

                                    <b-col cols="1" align-self="center">
                                        <b-icon icon="gear-wide" v-if="visibleFieldSettings" @click="startFieldEdit(value)"/>
                                    </b-col>                           
                            </b-row>

                        </b-col>
                    </component>

                    <template v-if="!model">
                        <b-form-group>
                            <b-skeleton :width="`${getSkeletonWidth()}%`" :height="`${getSkeletonHeight()}px`" class="fieldSkeleton" animation="throb"/>
                        </b-form-group>
                        <b-form-group>
                            <b-skeleton :width="`${getSkeletonWidth()}%`" :height="`${getSkeletonHeight()}px`" class="fieldSkeleton" animation="throb"/>
                        </b-form-group>
                        <b-form-group>
                            <b-skeleton :width="`${getSkeletonWidth()}%`" :height="`${getSkeletonHeight()}px`" class="fieldSkeleton" animation="throb"/>
                        </b-form-group>
                    </template>

                </b-tab>
                <b-tab v-if="model">
                    <template slot="title">
                        <span>{{ $t('systemInfo') }}</span>
                    </template>
                    <b-row>
                        <b-col cols="12" align-self="center">
                            <b-form-group
                                :label="$t('createdBy')"
                                :horizontal="true">
                                <b-form-input :disabled="true" type="text" :value="model.created_by"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group
                                :label="$t('createdAt')"
                                :horizontal="true">
                                <b-form-input :disabled="true" type="text" :value="$toUserTimeZone(model.created_at)"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group
                                :label="$t('updatedBy')"
                                :horizontal="true">
                                <b-form-input :disabled="true" type="text" :value="model.updated_by"></b-form-input>
                            </b-form-group>    
                        </b-col>
                        
                        <b-col cols="12">
                            <b-form-group
                                :label="$t('updatedAt')"
                                :horizontal="true">
                                <b-form-input :disabled="true" type="text" :value="$toUserTimeZone(model.updated_at)"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>
            <div class="row" v-if="model">
                <slot name="controls" :save="save" :remove="remove" :deleteButtonBudy="deleteButtonBusy" :component="component" :saveButtonBusy="saveButtonBusy">
                    <div class="col-sm-3" v-if="$can('edit ' + component.general.name)">
                        <b-button type="submit" class="btn btn-success btn-block active mt-2 mr-2" v-on:click="save">
                            <b-spinner small v-if="saveButtonBusy"></b-spinner>
                            <span v-if="!saveButtonBusy">{{ $t('save') }}</span>
                        </b-button>
                    </div>
                    <div class="col-sm-3" v-if="$can('delete ' +  component.general.name)">
                        <b-button type="button" class="btn btn-danger btn-block active mt-2 mr-2" v-on:click="remove">
                            <b-spinner small v-if="deleteButtonBusy"></b-spinner>
                            <span v-if="!deleteButtonBusy">{{ $t('delete') }}</span>
                            </b-button>
                    </div>
                </slot>
            </div>

            <b-sidebar id="template" right title="Fields" v-model="visibleFieldSettings" v-if="$can('settings ' + this.component.general.name) && $isPlatformEnv('dev')">
                <DraggableFields :group="{ name: 'fields', pull: 'clone', put: false }" :mutateClone="onClone" @dragStart="draggingInProcess = true" @dragEnd="draggingInProcess = false"/>
            </b-sidebar>

            <b-sidebar right v-model="editingField.show">
                <FieldEdit v-model="editingField.field" :key="version" v-if="editingField.field" :fields="fields" :component="component"></FieldEdit>

                <template #footer>
                    <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
                        <b-button variant="success" size="sm" @click="editField">{{ $t('save') }}</b-button>
                        <b-button variant="danger" size="sm" @click="removeField" class="ml-1">{{ $t('delete') }}</b-button>
                    </div>
                </template>
            </b-sidebar>
        </form>

        <b-modal title="Performing action" v-model="actionModal.processing"
        o-close-on-esc no-close-on-backdrop  hide-header-close hide-footer 
        >
            <div class="d-flex align-items-center">
                {{ actionModal.actionName }}
                <b-spinner variant="primary" class="ml-4"></b-spinner>
            </div>
        </b-modal>

        <protokol-floating-settings v-if="$can(`settings ${component.general.name}`) && $isPlatformEnv('dev') && $screen.md" >
            <template v-slot="{toggleSettings}">
                <b-button variant="dark" @click="visibleFieldSettings = true; toggleSettings()"> <b-icon icon="gear" /> </b-button>
            </template>
        </protokol-floating-settings>
    </b-col>

    <b-skeleton width="100%" height="250px" v-else animation="throb"/>
</template>

<script>

import { 
    Thunder,
    Context,
    Model,
    Workflow
} from '@protokol/platform-libs'

import IdentityFields from '@/components/identityFields/IdentityFields'
import safeEval from 'safe-eval'
import _ from "lodash"
import moment from 'moment'
import DraggableFields from './Settings/DraggableFields.vue'
import FieldEdit from './Settings/FieldEdit.vue'
import draggable from 'vuedraggable'
import SelectRelationUI from '../identityFields/ui/SelectRelation.vue'
import MediaLibrary from '@/components/integrations/protokol/media/Index'
import ComponentView from './ComponentView.vue'

export default {
    name: "DefaultEdit",
    components: {
        IdentityFields,
        DraggableFields,
        FieldEdit,
        draggable,
        SelectRelationUI,
        ComponentView,
        MediaLibrary
    },
    props: {
        id: {
            type: String,
            default: null
        },
        modelUuid: {
            type: String,
            default: null
        },
        component: {
            type: Object
        },
        settings: {
            type: Object,
            default: () => {
                return {
                    container: {
                        cols: 12,
                        md: 6
                    },

                    slotless: false
                }
            }
        }
    },
    data: () => {
        return {
            ready: false,
            model: {},
            aModel: {},
            oldModel: '',
            saveButtonBusy: false,
            deleteButtonBusy: false,
            enableButtonBusy: false,
            errors: [],
            actionModal: {
                processing: false,
                actionName: ''
            },
            httpErrors: [],
            actionPopup: {
                show: false,
                action: {}
            },
            version: 0,
            visibleFieldSettings: false,
            editingField: {
                field: null,
                fieldOld: null,
                show: false
            },
            draggingInProcess: false
        }
    },

    computed: {
        input: {
            get() {
                return this.model
            },
            
            set(e) {
                if (typeof e !== 'object') {
                    console.error(`Invalid input. If you are trying to emit input event then you should try to pass an object. Ex: {field: value}`)
                    return
                }

                const data = e || {}
                let model = this.model || {}

                this.model = Object.assign({}, model, data)
                this.$emit('modelChanged', this.model)
            }
        },

        actionInput: {
            get() {
                return this.aModel
            },
            
            set(e) {
                this.aModel = {...this.aModel, ...e}
            }
        },
        
        sortedFields: {
            set(val) {
                this.component.settings.fields = val

                this.$store.dispatch("updateComponentSettings", this.component).then((settings) => {
                    this.component = settings
                })
            },

            get() {
                let fields = _.cloneDeep(this.fields || [])

                fields.sort((a, b) => {
                    return a.sortOrder - b.sortOrder
                })

                return fields
            }
        },

        draggableFields() {
            if (this.visibleFieldSettings) {
                return this.sortedFields
            }

            return []
        },

        fieldGroups() {
            try {
                let groups = {
                '': true
                }
                
                this.fields.forEach(f => {
                    const group = f.group || ''
                    
                    groups[group] = true
                })

                return Object.keys(groups);
            } catch(err) {
                this.$debugLog(err)

                return ['']
            }
        },

        context() {
            return new Context({
                model: _.cloneDeep(this.model), 
                locale: this.$store.getters.getLocale
            })
        },

        fields() {
            return this.component.settings.fields
        },

        wrapperComponent() {
            if (this.visibleFieldSettings) {
                return {
                    tag: 'div',
                    class: {
                        row: true
                    },
                    'v-model': "sortedFields",
                    group: "fields"
                }
            }

            return {}
        },

        wrapperComponentElement() {
            if (this.visibleFieldSettings) {
                return 'draggable'
            }

            return 'b-row'
        }
    },
    methods: {
        isModelChanged() {
            return JSON.stringify(this.model) != JSON.stringify(this.oldModel)
        },

        onMove(e) {
            console.log("onMove", e)
        },

        onClone(original) {
            original.name = `Field${this.sortedFields.length}`
            original.key = `field${this.sortedFields.length}`
            original.group = this.fieldGroups[this.currentTab]

            return original;
        },

        startFieldEdit(field) {
            this.editingField.show = true
            this.editingField.field = field
            this.editingField.fieldOld = _.cloneDeep(field)
        },

        removeField() {
            this.$bvModal.msgBoxConfirm('Are you sure?').then((value) => {
                if (value) {
                    const fields = this.sortedFields.filter(f => {
                        return f.key != this.editingField.field.key
                    })

                    this.sortedFields = fields
                    this.editingField.show = false
                }
            })
        },

        editField() {
            let field = this.editingField.field
            let oldField = this.editingField.fieldOld

            let fields = this.sortedFields.map(el => {
                if (el.key == oldField.key) {
                return field
                } else {
                return el
                }
            });

            this.editingField.show = false

            this.sortedFields = fields

            this.version++
        },

        groupName(group) {
            return _.capitalize(group)
        },

        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },
        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },
        save(e) {
            e.preventDefault()
            
             if (this.checkForErrors()) {
                this.$bvToast.toast(this.$t('fieldsNotValid'), {
                    variant: 'danger',
                    title: this.$t('error')
                })
                this.saveButtonBusy = false

                return
            }


            const componentUuid = this.getComponentUUID()

            const popup = this.$loadingPopup()

            this.$component(componentUuid).store().update(this.getModelUUID(), {
                version: this.model.__version__,
                data: this.model
            }).then((resp) => {
                this.$bvToast.toast(this.$t('Saved'), {
                    variant: 'success',
                    title: this.$t('success')
                })

                this.model = resp.data

                this.$store.commit("SET_COMPONENTS_MODEL", {uuid:componentUuid, results: this.model})

                this.$emit('saved', this.model)

                this.oldModel = _.cloneDeep(this.model)
            }).catch((error) => {
                if (error.response !== undefined) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }

                    if (error.response.status == 417) {
                        this.httpErrors = error.response.data.errors
                        return
                    }

                    if (error.response.status == 409) {
                        this.$bvToast.toast(this.$t('concurrentModelUpdate'), {
                            variant: 'warning'
                        })
                        return
                    }

                    this.$bvToast.toast(error.response.data.message, {
                        variant: 'danger'
                    })
                }


                this.$debugLog(error)
            }).finally(() => {
                popup.hide()
            })
        },

        remove() {
            let componentUuid = this.getComponentUUID()

            this.$bvModal.msgBoxConfirm(this.$t('areYouSure')).then(resp => {
                if (resp) {
                    this.deleteButtonBusy = true
                    this.$component(componentUuid).store().delete(this.getModelUUID()).then((resp) => {
                        this.deleteButtonBusy = false
                        this.$store.commit("REMOVE_COMPONENTS_MODEL", {uuid: componentUuid, model_uuid: this.getModelUUID()})
                        this.$router.back()
                    }).catch((error) => {
                        if (error.response !== undefined) {
                            if (error.response.status == 500) {
                                this.$serverErrorModal(error)
                                this.deleteButtonBusy = false
                                return
                            }

                            this.$bvToast.toast(error.response.data.message, {
                                variant: 'danger'
                            })
                        }
                        

                        this.deleteButtonBusy = false
                    })
                }
            })
        },

        actionClick(action) {
            let { fields = [] } = action

            if (fields === null) {
                this.doAction(action)
                return
            }


            if (fields.length > 0) {
                this.openActionPopup(action) 
            } else {
                this.doAction(action)
            }
        },

        openActionPopup(action) {
            this.actionPopup.show = true;
            this.actionPopup.action = action;
        },

        doAction(action) {
            this.actionModal.processing = true;
            this.actionModal.actionName = action.name;

            let cont = safeEval("(async function() { try {"+action.action+" return model; } catch (error) { return error; } }());", {
                model: new Model(this.model, {locale: this.$store.getters.getLocale}),
                _: _,
                moment: moment,
                input: this.aModel,
                thunder: new Thunder(this.$store),
                workflow: new Workflow(this.$store, this.getComponentUUID(), this.model.uuid)
            })

            Promise.resolve(cont).then(val => {
                if (val && val.stack && val.message) {
                    this.actionModal.processing = false
                    this.$bvModal.msgBoxOk("Action "+ action.name +" evaluation error: " + val.message)
                    return
                }

                if (val !== undefined) {
                    this.actionModal.processing = false;
                    this.model = val
                }
            
            }).catch(err => {
                this.$bvModal.msgBoxOk("Action "+ action.name +" evaluation error: " + err.message)
            })

        },

        cleanErrors(m) {
            this.httpErrors = []
        },

        isQuickEdit() {
            return this.id !== null
        },

        getComponentUUID() {
            return this.id || this.$route.meta.ref
        },

        getModelUUID() {
            return this.modelUuid
        },

        lgSize() {
            return this.isQuickEdit() ? 12 : 6
        },

        getSkeletonWidth() {
            return _.random(20, 100)
        },

        getSkeletonHeight() {
            return _.random(5, 30)
        }
    },

    updated() {
        console.log("[Render] DefaultEdit rendered")
    },

    created() {
        let componentUuid = this.getComponentUUID()
        this.model = _.cloneDeep(this.$store.getters.componentModel(componentUuid, this.getModelUUID()))
        if (!this.model) {
            this.$component(componentUuid).store().getModelByUUID(this.getModelUUID(), {}).then(resp => {
                this.model = _.cloneDeep(resp.data)
                this.oldModel = _.cloneDeep(this.model)
                this.ready = true
                this.$emit('modelChanged', this.model)
            }).catch((error) => {
                if (error.response !== undefined) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }

                    this.$bvToast.toast(error.response.data.message, {
                        variant: 'danger'
                    })
                    return
                }

                this.$debugLog(error)
                
            })
        }

    }
}
</script>

<style lang="scss" scoped>
.fieldEditing {
    border-bottom: 10px solid #2C3135;
    transition: border-width 0.5s linear;
    margin-left: -17px;
    margin-right: -17px;
}
</style>